import on from "../dom/on"

type Handler = (target: Element, event: Event) => void

interface DomUpdateHandlers {
  after?: Handler
  before?: Handler
  login?: Handler
  logout?: Handler
  signup?: Handler
}

export default ({
  after,
  before,
  login,
  logout,
  signup,
}: DomUpdateHandlers) => {
  if (after) {
    on("after_json", null, after)
    on("site_init", null, after)
  }
  if (before) {
    on("before_json", null, before)
  }
  if (login) {
    on("user_login", null, login)
  }
  if (logout) {
    on("user_logout", null, logout)
  }
  if (signup) {
    on("user_signup", null, signup)
  }
}
